'use client';

import React from 'react';
import { LearnSectionLabel } from './LearnSectionLabel';

export interface LearnPresentedByProps {
  logo?: string;
  align?: 'start' | 'center';
  className?: string;
}

export const LearnPresentedBy: React.FC<LearnPresentedByProps> = ({ logo, align = 'start', className = '' }) => {
  if (!logo) return null;

  return (
    <div className={`flex flex-col gap-2 ${align === 'center' ? 'items-center' : 'items-start'} ${className}`}>
      <LearnSectionLabel className="mb-0 whitespace-nowrap" label="Presented By" />
      <img alt="Presented by" className="w-auto max-h-[60px]" src={logo} />
    </div>
  );
};

export default LearnPresentedBy;
